import { Admin } from './admin/Admin';
import { Auth } from './auth/Auth';
import { RestPolling } from './rest-polling/RestPolling';
import { Rest } from './rest/Rest';
import { BaseStreaming } from './streaming/base/Streaming';
import { BrokerageStreaming } from './streaming/brokerageTrading/Streaming';
import { ReTradeStreaming } from './streaming/reTrading/Streaming';
import { UserData } from './user-data/UserData';
import { BrowserData } from './browserdata/BrowserData';

import config from './config';

class SDK {
  config = config;
  Auth: Auth;

  /**
   * @deprecated Use `Auth` instead
   */
  public get ServiceAuth() {
    return this.Auth;
  }

  //#region Admin
  private _admin?: Admin;
  public get Admin() {
    if (!this._admin)
      throw new Error(
        'Admin service not installed, use "sdk.use()" to install it'
      );
    return this._admin;
  }
  /**
   * @deprecated Use `Admin` instead
   */
  public get ServiceAdmin() {
    return this.Admin;
  }
  //#endregion

  //#region Rest
  private _rest?: Rest;
  public get Rest() {
    if (!this._rest)
      throw new Error(
        'Rest service not installed, use "sdk.use()" to install it'
      );
    return this._rest;
  }
  /**
   * @deprecated - Use `Rest` instead
   */
  public get ServiceRest() {
    return this.Rest;
  }
  //#endregion

  //#region RestPolling
  private _restPolling?: RestPolling;
  /**
   * @deprecated
   */
  public get RestPolling() {
    if (!this._restPolling)
      throw new Error(
        'RestPolling service not installed, use "sdk.use()" to install it'
      );
    return this._restPolling;
  }
  /**
   * @deprecated
   */
  public get ServiceRestPolling() {
    return this.RestPolling;
  }
  //#endregion

  //#region Base Streaming
  private _streaming?: BaseStreaming;
  public get BaseStreaming() {
    if (!this._streaming)
      throw new Error(
        'Streaming service not installed, use "sdk.use()" to install it'
      );
    return this._streaming;
  }
  /**
   * @deprecated Use `BaseStreaming` instead
   */
  public get ServiceStreaming() {
    return this.BaseStreaming;
  }
  /**
   * @deprecated Use `BaseStreaming` instead
   */
  public get Streaming() {
    return this.BaseStreaming;
  }
  //#endregion

  //#region ReTrade Streaming
  private _reTradeStreaming?: ReTradeStreaming;
  public get reTradeStreaming() {
    if (!this._reTradeStreaming)
      throw new Error(
        'ReTradeStreaming service not installed, use "sdk.use()" to install it'
      );
    return this._reTradeStreaming;
  }
  //#endregion

  //#region Brokerage Streaming
  private _brokerageStreaming?: BrokerageStreaming;
  public get brokerageStreaming() {
    if (!this._brokerageStreaming)
      throw new Error(
        'BrokerageStreaming service not installed, use "sdk.use()" to install it'
      );
    return this._brokerageStreaming;
  }
  //#endregion

  //#region UserData
  private _userData?: UserData;
  public get UserData() {
    if (!this._userData)
      throw new Error(
        'UserData service not installed, use "sdk.use()" to install it'
      );
    return this._userData;
  }
  /**
   * @deprecated Use `UserData` instead
   */
  public get ServiceUserData() {
    return this.UserData;
  }
  //#endregion

  //#region BrowserData
  private _browserData?: BrowserData;
  public get BrowserData() {
    if (!this._browserData)
      throw new Error(
        'BrowserData service not installed, use "sdk.use()" to install it'
      );
    return this._browserData;
  }
  //#endregion

  constructor() {
    this.Auth = new Auth(config);
  }

  use(service: { install(instance: SDK): void }) {
    service.install(this);
  }
}

const sdk = new SDK();
sdk.use(Admin);
sdk.use(Rest);
sdk.use(BaseStreaming);
sdk.use(UserData);
sdk.use(BrowserData);

export default sdk;

export {
  SDK,
  Admin,
  Rest,
  RestPolling,
  BaseStreaming,
  ReTradeStreaming,
  BrokerageStreaming,
  UserData,
  BrowserData,
};
